import type { CmsApiFourArticlesHighlightBlockData } from '#/modules/cms/api/types/blocks/CmsApiFourArticlesHighlightBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

import { CmsFourArticlesHighlightBlock } from './CmsFourArticlesHighlightBlock';

export const CmsFourArticlesHighlightBlockMapping: CmsBlockMapping<CmsApiFourArticlesHighlightBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsFourArticlesHighlightBlock,
  };
